/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";

import { CreateActionsBaseParams } from "../CreateActionsBaseParams";

import { SingleSelectActions } from "./SingleSelectActions";
import { SingleSelectState } from "./SingleSelectState";

/**
 * Creates single select actions.
 * @param params The parameters.
 * @returns The created actions.
 */
export function createSingleSelectActions<TValue, TState extends SingleSelectState<TValue>>(
    params: CreateActionsBaseParams<TState>
): SingleSelectActions<TValue> {
    const { namespace, store } = params;

    return {
        clearSingleSelection: mutatorAction(`${namespace}ClearSingleSelection`, () => {
            store().selectedValue = undefined;
        }),

        selectSingle: mutatorAction(`${namespace}SelectSingle`, (value?: TValue) => {
            store().selectedValue = value;
        })
    };
}
